import {observer, shallowEquals} from 'redux-observers';
import {getPricingWatchedValues, PricingWatchedValues} from '../pricing/selectors';
import {pricingObserverPriceFetch} from '../pricing/thunks';

export const fetchPriceObserver = observer(getPricingWatchedValues, (dispatch: any, current: PricingWatchedValues, previous?: PricingWatchedValues) => {
  if (previous && current.sessionId && !shallowEquals(previous, current)) {
    dispatch(pricingObserverPriceFetch());
  }
});
